import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useLazyQuery, gql } from '@apollo/client'
import { setIsColleagueSearchable, setIsManualEntry } from '../features/Searchee/searcheeSlice'

function useColleagueData() {
  const siteLocationCode = useSelector((state) => state.site.primaryAssigned.locationCode)
  const searchId = useSelector((state) => state.search.id)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const GET_COLLEAGUES = gql`
    query ($locationCode: String!, $searchId: String!) {
      colleagueDataByStore(siteLocationCode: $locationCode, searchId: $searchId) {
        colleagueID,
        azureID,
        person {
          title,
          firstName,
          lastName,
          middleName,
          preferredName
        },
        assignment {
          status,
          effectiveDate,
          lineManagerId,
          lineManagerName,
          department,
          secondaryDepartment,
          jobCode,
          jobName,
          positionCode,
          positionName,
          jobGrade,
          employeeType,
          businessUnit,
          storeType,
          legalEntity,
          locationCode,
          secondaryLocationCode
        },
        email {
          emailAddress,
          primaryFlag,
          emailType
        },
        dateLastUpdated
      }
    }
  `
  const [getColleagueData, { data, loading, error }] = useLazyQuery(GET_COLLEAGUES, {
    variables: { locationCode: siteLocationCode, searchId }
  })

  useEffect(() => {
    if (siteLocationCode !== null && searchId !== null) {
      getColleagueData({ variables: { locationCode: siteLocationCode, searchId } })
        .then((response) => {
          if (response?.data?.colleagueDataByStore?.length === 0) {
            dispatch(setIsManualEntry(true))
            dispatch(setIsColleagueSearchable(false))
          }
        })
    }
  }, [siteLocationCode, searchId, getColleagueData, dispatch])

  function colleagueData() {
    return new Promise((resolve) => {
      const colleagueList = data?.colleagueDataByStore.map((x) => ({
        label: `${x.person.firstName ?? ''} ${x.person.lastName ?? ''} (${x.colleagueID ?? ''})`,
        // eslint-disable-next-line max-len
        value: `${x.person.firstName ?? ''} ${x.person.lastName ?? ''}|(${x.colleagueID ?? ''})|${x.assignment?.jobName ?? ''}|${x.assignment?.businessUnit ?? ''}|${x.assignment?.locationCode ?? ''}|${x.assignment?.department ?? ''}`
      }))
      resolve(colleagueList)
    })
  }

  const getColleagueOptions = () => colleagueData().then((response) => response)
    .catch((err) => {
      window.localStorage.removeItem('searchId')
      if (err.toString().includes('Forbidden')) {
        navigate('/forbidden')
      }
    })

  return {
    getColleagueOptions,
    loading,
    error
  }
}

export default useColleagueData
